import React, { useState } from "react";
import "./component.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import SingingContract from "../../../assests/SingingContract.svg";
import { Button, Box, TextField } from "@mui/material";
import leftArrow from "../../../assests/leftArrow.svg";
import { Link, useNavigate, useHistory } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import LoadingSpinner from "../../Loading/component";

export const CouponUseDurationComponent = ({
   
    couponCreationStep14,
    
    handleBtnClick,
    activeBtn,
    couponDuration,
couponFrequency,
handleChangeCouponDuration,
handleChangeCouponFrequency,
}) => {
    // const [activeBtn, setActiveBtn] = useState("flat");
    // const [cashbackAmount, setCashbackAmount] = useState("");
  
    // const handleBtnClick = (type) => {
    //     setActiveBtn(type);
    //     if (type === 'flat') {
    //       couponCreationStep10(1);
    //     } else if (type === 'percentage') {
    //       couponCreationStep10(2);
    //     }
    //   };
      
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/home/coupon/list");
  };
  const goback = () => {
    navigate(-1);
  };
  
  return (
    <div className="main-div">
      <div>
        <Sidebar />
      </div>

      <div>
        <div style={{ marginLeft: "42px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={handleClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Create Coupon
          </h2>
        </div>
        <div className="bDetrails-div">
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              width: "1328px",
            }}
          >
            <div className="inputDiv">
      <Box
        sx={{
          width: 600,
          maxWidth: "100%",
          alignItems: "center"
        }}
      >
        <label htmlFor="" className="couponLabel" style={{width:"1090px"}}>
        Do you want to add a limit on the number of times this coupon can be used by a user in a day/week/month?
        </label>
        <div>
        <div className="cashback-div">
      <button
        className={`cashback-btn ${
          activeBtn === "Yes" ? "active-btn" : "inactive-btn"
        }`}
        onClick={() => handleBtnClick("Yes")}
      >
        Yes
      </button>
      <button
        className={`cashback-btn ${
          activeBtn === "No" ? "active-btn" : "inactive-btn"
        }`}
        onClick={() => handleBtnClick("No")}
      >
        No
      </button>
     
    </div>

        
 {activeBtn === "Yes" && (
    <>
       <TextField
       style={{ margin: "18px", padding: "0px", color: "#b2b2b2" }}
       fullWidth
       label="Usage limit per coupon"
      type="number"
       value={couponFrequency}
       onChange={handleChangeCouponFrequency}
     />
      <TextField
       style={{ margin: "18px", padding: "0px", color: "#b2b2b2" }}
       fullWidth
       label="Duration in Days"
      type="number"
       value={couponDuration}
       onChange={handleChangeCouponDuration}
     />

     </>
     
      )}

        </div>
          <Box className="usersrolebtn" >
        <Button className="backbtn" onClick={goback}>
          Cancel
        </Button>



<Button
            variant="contained"
            onClick={couponCreationStep14}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              height: 40,
              background:"rgba(0, 177, 119, 1)",
            }}
          >
            NEXT
          </Button>


      </Box>
      </Box>
     
     
    
      
    </div>
          </div>
          
        </div>
        
      </div>
    </div>
  );
};
